import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import Dashboard from '../../Dashboard';

import BPIndex from './_bp/BPIndex';
import DetailBp from './_bp/DetailBp';

// import IndexSTS from './_sts/IndexSTS';
import ListParaf from './_paraf/ListParaf';
import ListBank from './_bank/ListBank';
import ListKuasa from './_kuasa/ListKuasa';
import Profile from './_profile/Profile';
import BPAdd from './_bp/BPAdd';
// import BPAddSingle from './_bp/BPAddSingle';
// import SingleSTSAdd from './_sts/SingleSTSAdd'
import BPNonSTS from './_bp/BPNonSTS'
import Report from './_report/ReportIndex';
import ListSTS from './_sts/ListSTS';


export default class OpdView extends React.Component {
   render() {
      return (
         <div>
            <Switch>
               <Route path={"/b/dashboard"} name="dashboard" component={Dashboard} />               
               <Route path={"/b/bp/detail/:id"} name="bp-detail" component={DetailBp} />
               <Route path={"/b/bp"} name="bp" component={BPIndex} />
               <Route path={"/b/newbp"} name="new-bp" component={BPAdd} />
               <Route path={"/b/newsts"} name="new-sts" component={BPNonSTS} />

               <Route path={"/b/sts"} name="sts" component={ListSTS} />
               <Route path={"/b/paraf"} name="paraf" component={ListParaf} />
               <Route path={"/b/bank"} name="bank" component={ListBank} />
               <Route path={"/b/kuasa"} name="kuasa" component={ListKuasa} />
               <Route path={"/b/profile"} name="profile" component={Profile} />
               <Route path={"/b/report"} name="report" component={Report} />
               <Redirect from="/b" to="/b/dashboard" />
            </Switch>
         </div>
      );
   }
}



// WEBPACK FOOTER //
// ./src/components/Content/views/opd/opd.view.js